import { Australia } from "@faire/icons/flags/Australia";
import { Austria } from "@faire/icons/flags/Austria";
import { Belgium } from "@faire/icons/flags/Belgium";
import { Canada } from "@faire/icons/flags/Canada";
import { Denmark } from "@faire/icons/flags/Denmark";
import { Finland } from "@faire/icons/flags/Finland";
import { France } from "@faire/icons/flags/France";
import { Germany } from "@faire/icons/flags/Germany";
import { Ireland } from "@faire/icons/flags/Ireland";
import { Italy } from "@faire/icons/flags/Italy";
import { Japan } from "@faire/icons/flags/Japan";
import { Korea } from "@faire/icons/flags/Korea";
import { Luxembourg } from "@faire/icons/flags/Luxembourg";
import { Netherlands } from "@faire/icons/flags/Netherlands";
import { NewZealand } from "@faire/icons/flags/NewZealand";
import { Norway } from "@faire/icons/flags/Norway";
import { Portugal } from "@faire/icons/flags/Portugal";
import { Spain } from "@faire/icons/flags/Spain";
import { Sweden } from "@faire/icons/flags/Sweden";
import { Switzerland } from "@faire/icons/flags/Switzerland";
import { UnitedKingdom } from "@faire/icons/flags/UnitedKingdom";
import { UnitedStates } from "@faire/icons/flags/UnitedStates";
import { SVGIconComponent } from "@faire/slate/icons/types";
import { ISO3166Alpha3 } from "@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3";

export const ISO_COUNTRY_TO_FLAG_ICON: Partial<
  Record<keyof typeof ISO3166Alpha3, SVGIconComponent>
> = {
  [ISO3166Alpha3.USA]: UnitedStates,
  [ISO3166Alpha3.AUT]: Austria,
  [ISO3166Alpha3.AUS]: Australia,
  [ISO3166Alpha3.BEL]: Belgium,
  [ISO3166Alpha3.CAN]: Canada,
  [ISO3166Alpha3.DNK]: Denmark,
  [ISO3166Alpha3.FIN]: Finland,
  [ISO3166Alpha3.FRA]: France,
  [ISO3166Alpha3.DEU]: Germany,
  [ISO3166Alpha3.IRL]: Ireland,
  [ISO3166Alpha3.ITA]: Italy,
  [ISO3166Alpha3.LUX]: Luxembourg,
  [ISO3166Alpha3.NLD]: Netherlands,
  [ISO3166Alpha3.NOR]: Norway,
  [ISO3166Alpha3.PRT]: Portugal,
  [ISO3166Alpha3.ESP]: Spain,
  [ISO3166Alpha3.SWE]: Sweden,
  [ISO3166Alpha3.CHE]: Switzerland,
  [ISO3166Alpha3.GBR]: UnitedKingdom,
  [ISO3166Alpha3.JPN]: Japan,
  [ISO3166Alpha3.KOR]: Korea,
  [ISO3166Alpha3.NZL]: NewZealand,
};
